import { BETA_AI_RISK_REPORT_ROOT_PATH } from '../../../../router/constants'

export const AI_RISK_REPORT_CHANNELS = {
  BETA: 'beta',
  GA: 'ga',
}

export const AI_RISK_REPORT_CHANNEL_VALUES = Object.values(AI_RISK_REPORT_CHANNELS)
export const DEFAULT_AI_RISK_REPORT_CHANNEL = AI_RISK_REPORT_CHANNELS.GA

export const getAIRiskReportChannelFromPath = (pathname) =>
  pathname?.startsWith(BETA_AI_RISK_REPORT_ROOT_PATH) ? AI_RISK_REPORT_CHANNELS.BETA : DEFAULT_AI_RISK_REPORT_CHANNEL
